/**
 * RunningIndicator — pulsing dot shown in place of the CheckCircle while a tool
 * is still executing. Kept in its own component-only module (the status logic
 * lives in toolRunning.ts) so this file satisfies react-refresh's
 * only-export-components rule.
 */
import type { ReactElement } from 'react';

/**
 * Pulsing dot indicator for an in-flight tool call. Uses Tailwind `animate-pulse`
 * (className, never inline style).
 */
export function RunningIndicator({
  className = '',
}: {
  className?: string;
}): ReactElement {
  return (
    <span
      role='status'
      aria-label='Running'
      className={`inline-block size-2 rounded-full bg-fg-quaternary animate-pulse ${className}`}
    />
  );
}
